import type { Route } from "../data/routes.data";

export function isPromo(routes: Route[]): boolean {
  let promo = false;

  routes.forEach(route => {
    if (route.image) {
      promo = true;
      return promo;
    }
  });

  return promo;
}

// btoa implementation that works across Javascript and Node
// const universalBtoa = str => {
//   try {
//     return btoa(str);
//   } catch (err) {
//     return Buffer.from(str).toString("base64");
//   }
// };

// atob implementation that works across Javascript and Node
const universalAtob = (str: string) => {
  try {
    return atob(str);
  } catch (err) {
    return Buffer.from(str, "base64").toString("binary");
  }
};

// lookup Shopify collection ID from route config
export function getCollectionID(
  route: Route,
  region: "uk" | "us" | "de" | "eu" | "row" | "staging" | "dev",
): string {
  if (!route) {
    return "";
  }
  return route.regionColID[region].toString();
}

// lookup matching route from config
export function getRoute(
  routes: Route[],
  landing: string,
  collection: string,
): Route {
  const [, collectionRoute] = getRouteHierarchy(routes, landing, collection);
  if (!collectionRoute) {
    return;
  }
  return collectionRoute;
}

export function shopifyID(resource: string, id: string): string {
  // return universalBtoa(`gid://shopify/${resource}/${id}`);
  return `gid://shopify/${resource}/${id}`;
}

export function idFromShopify(id: string): string {
  // return universalAtob(id).replace(/gid:\/\/shopify\/.*\//, "");
  return id?.replace(/gid:\/\/shopify\/.*\//, "");
}

function findRoute(routes: Route[], slug: string): Route {
  return routes.find(route => {
    const parts = route.href.split("/");
    if (parts[parts.length - 1] === slug) {
      return true;
    }
  });
}

// lookup the route hierarchy for a particular collection
function getRouteHierarchy(
  routes: Route[],
  landing: string,
  collection: string,
): Route[] {
  const landingRoute = findRoute(routes, landing);
  if (!landingRoute) {
    return [];
  }
  let route: Route;
  if (collection && landingRoute.routes && landingRoute.routes.length) {
    // top-level
    route = findRoute(landingRoute.routes, collection);
    if (route) {
      return [landingRoute, route];
    }
    // sub-level
    for (let i = 0; i < landingRoute.routes.length; i++) {
      const r = landingRoute.routes[i];
      if (!r.routes) {
        continue;
      }
      const subRoute = findRoute(r.routes, collection);
      if (subRoute) {
        route = subRoute;
        break;
      }
    }
  }
  return [landingRoute, route];
}

// flattens the full routes array recursively
function routeFlattener(routes: Route[]): Route[] {
  const flat: Route[] = [];
  const flattener = (routes: Route[]) => {
    routes.forEach(route => {
      flat.push(route);
      if (route.routes) {
        flattener(route.routes);
      }
    });
  };
  flattener(routes);
  return flat;
}

export function findRouteByCollection(
  routes: Route[],
  collectionID: string,
  region: string,
): Route {
  const id = universalAtob(collectionID).replace(
    "gid://shopify/Collection/",
    "",
  );
  return routes.find(
    (r: any) =>
      r.regionColID &&
      r.regionColID[region] &&
      r.regionColID[region].toString() === id,
  );
}

// lookup route by collection ID
export function getRouteByCollection(
  routes: Route[],
  landing: string,
  collectionID: string,
  region: string,
): Route {
  const landingRoute = findRoute(routes, landing);
  if (!landingRoute || !landingRoute.routes) {
    return;
  }
  // top-level
  let route = findRouteByCollection(landingRoute.routes, collectionID, region);
  if (route) {
    return route;
  }
  // sub-level
  for (let i = 0; i < landingRoute.routes.length; i++) {
    const r = landingRoute.routes[i];
    if (!r.routes) {
      continue;
    }
    const subRoute = findRouteByCollection(r.routes, collectionID, region);
    if (subRoute) {
      route = subRoute;
      break;
    }
  }
  return route;
}

// lookup routes without landing by collection ID only
export function findRoutesWithoutLanding(
  routes: Route[],
  collectionID: string,
  region: string,
): Route {
  const flattenRoutes = routeFlattener(routes);
  return flattenRoutes.find(
    (r: any) =>
      r.regionColID &&
      r.regionColID[region] &&
      r.regionColID[region].toString() === collectionID,
  );
}

export function mapParamsToCrumb(
  params: Record<string, string>,
  route: { id: string },
  search: string,
): any {
  const { landing, collection, slug } = params;
  //href should drop the first part of the path
  let parts = [landing, collection, slug].filter(Boolean);

  if (!parts.length) {
    const routeParts = route.id.split("/").filter(Boolean);
    //first element is always lang param so remove it
    routeParts.shift();
    parts = routeParts;

    if (!parts.length) parts[0] = "";
  }

  return {
    title: parts[parts.length - 1].replace(/-/g, " ") || "HOME", //assuming empty string to be home
    href: `${parts.join("/")}${search ? `${search}` : ""}`,
  };
}
